module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step1_Image21.ee8e0070.webp";